//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum TrainingEventStatus {
    Draft = 0,
    Published = 1,
    Cancelled = 2,
    Archived = 3,
}